import { CanActivateFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { AccountService } from '@services/account.service'

export const tenantGuard: CanActivateFn = (_, __) => {
	const account = inject(AccountService)
	const router = inject(Router)

	if (!account.tenantId) {
		router.navigate(['/organization/multi-tenant-select']).then()
		return false
	}

	return true
}
